import { useUserStore } from "@/modules/auth/store/user";
import { formatNumber } from "@/modules/auth/utils/format";
import { constants } from "@/modules/calculations/consts";
import { useTranslation } from "react-i18next";

const Vesting = () => {
  const { t } = useTranslation();

  const { vesting } = useUserStore();

  return (
    <div className="flex items-center justify-between gap-4 px-4 bg-bg rounded-[0.75rem]">
      <div className="flex items-center gap-4">
        <img src="/images/BTN.png" alt="" className="w-10 h-10 rounded-full" />

        <div className="flex flex-col py-3 gap-0.5">
          <p className="text-[1.0625rem] leading-[1.375rem] text-text">
            {t("main-page.vesting_balance")}
          </p>
          <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
            {formatNumber(vesting?.totalTokenAmount || 0, {
              precision: constants.TOKEN_DECIMALS,
            })}{" "}
            BTN
          </p>
        </div>
      </div>
    </div>
  );
};

export default Vesting;
